<template>
    <div>
          <headernavbar-view></headernavbar-view>
            <div class="inner_contents">
                <div class="container-fluid">
                  <router-view></router-view>
                </div>
          </div>
    </div>
</template>
<script>
    export default{
        name: "AppviewComponent",
        data: function () {
            return {
                

            }
        }
    }

</script>
<style scoped>


</style>
